export default __webpack_public_path__ + "static/media/circle-cropped (2).a800c78b.png";